// extracted by mini-css-extract-plugin
module.exports = {"Empty":"Empty--wJbB9","Header":"Header--17XCB","Content":"Content--3WArt","Icon":"Icon--3M7_0","IconBackground":"IconBackground--2XAiM"};